import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useAlert } from '../../contexts/AlertContext';

const Container = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 15px;
  backdrop-filter: blur(10px);
`;

const Title = styled.h1`
  color: white;
  margin: 0;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Button = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.1);
  padding: 25px;
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
`;

const CardTitle = styled.h3`
  color: white;
  margin: 0 0 20px 0;
  font-size: 1.5rem;
  font-weight: 600;
`;

const APIManagement = () => {
  const { addAlert } = useAlert();

  const handleCreateAPI = () => {
    addAlert({
      type: 'system',
      severity: 'low',
      title: 'API Endpoint Created',
      message: 'New API endpoint has been configured',
      category: 'api'
    });
  };

  return (
    <Container>
      <Header>
        <Title>🔌 API Management</Title>
        <Button onClick={handleCreateAPI}>
          ➕ Create API
        </Button>
      </Header>

      <Card>
        <CardTitle>API Integration Dashboard</CardTitle>
        <p style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
          Comprehensive API management for external integrations, service monitoring, 
          and developer tools for the commodity trading platform.
        </p>
      </Card>
    </Container>
  );
};

export default APIManagement; 